<template>
	<Popup
		v-model="selfDisplay"
		title="发货"
		@confirmClick="handleConfirmClick"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>发货公司</span>
				<el-input v-model="company" placeholder="发货公司"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="companyTip"><i class="b_icon"></i>请输入发货公司</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>快递单号</span>
				<el-input v-model="number" placeholder="快递单号"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="numberTip"><i class="b_icon"></i>请输入快递单号</template></div>
		</div>
	</Popup>
</template>

<script>
	import Api from '../../../../../../../api/index.js';
	
	export default{
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			orderId: {
				type: String,
				default: ''
			}
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data() {
			return{
				loading: false,
				selfDisplay: false,
				
				company: '',
				number: '',
				companyTip: false,
				numberTip: false
			}
		},
		methods: {
			// 点击确定
			handleConfirmClick() {
				if (!this.company.trim()) {
					this.companyTip = true;
					return false;
				} else {
					this.companyTip = false;
				}
				if (!this.number.trim()) {
					this.numberTip = true;
					return false;
				} else {
					this.numberTip = false;
				}
				this.send();
			},
			// 发货
			send() {
				const that = this;
				that.loading = true;
				let requestData = {
					orderId: that.orderId,
					expressCompany: that.company,
					expressNumber: that.number,
					typeChannel: 2
				};
				Api.setOrderSendForAppAndMall(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.$message.success(res.data.message);
						that.selfDisplay = false;
						that.$emit('onSuccess');
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display(newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay(newVal) {
				this.$emit("changeDisplay", newVal);
				if (!newVal) {
					this.loading = false;
					this.company = '';
					this.number = '';
					this.companyTip = false;
					this.numberTip = false;
				}
			}
		}
	}
</script>

<style>
</style>
